import React from "react";
import PropTypes from "prop-types";

import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

const Portfolio = ({ title, component }) => {
  return (
    <Box sx={{ p: 1 }}>
      <Paper elevation={3}>
        <Box sx={theme => ({ p: 2 })}>
          <Typography variant="h6" id="tableTitle">
            {title}
          </Typography>
        </Box>
        <Box
          sx={theme => ({
            backgroundColor: "#f4f6f8",
            p: 2,
          })}>
          {component}
        </Box>
      </Paper>
    </Box>
  );
};

Portfolio.defaultProps = {};

Portfolio.propTypes = {
  component: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
};

export default Portfolio;
